import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "click-box",
  class: "tw-relative tw-w-[421px] tw-px-[12px]"
}
const _hoisted_2 = { class: "tw-text-[#211F58] tw-text-[22px] tw-font-semibold tw-text-center tw-leading-[100%] tw-pb-[20px]" }
const _hoisted_3 = { class: "tw-text-[#231F20] tw-text-[13px] tw-not-italic tw-font-normal tw-leading-[normal] tw-text-center" }
const _hoisted_4 = { class: "tw-text-center" }

import { getComponentUiText } from "@/utils/utilities";
import router from "@/router";
import store from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'noDataCyberProfile',
  props: {
  isNoData: {
    type: Boolean,
    required: true,
  },
  idChecklist: {
    type: Number,
    default: 0,
    required: false,
  },
},
  emits: ["update-path"],
  setup(__props, { emit }) {

const props = __props;





const rejectAssessment = () => {
  store.dispatch("Navigation/setActiveHierarchy", [
    getComponentUiText("app-menu-submenu-assess-assessments-1"),
    "",
    "",
    "",
  ]);
  store.dispatch("Navigation/setPrimaryMenuIndex", 2);
  router.push({
    name: "Assessment",
    query: {
      param: "OpenModalAssessment",
    },
  });
};

const rejectRecommendation = () => {
  store.dispatch("Navigation/setActiveHierarchy", [
    getComponentUiText("app-menu-submenu-assess-recommendations-1"),
    "",
    "",
    "",
  ]);
  store.dispatch("Navigation/setPrimaryMenuIndex", 3);
  router.push({
    path: "/assess/roadmap",
    query: {
      id: props.idChecklist,
    },
  });
};

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(getComponentUiText)("app-dashboard-cyber-health-no-data-title-1")), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(__props.isNoData
          ? _unref(getComponentUiText)("app-dashboard-cyber-health-no-data-note-1")
          : _unref(getComponentUiText)("app-dashboard-cyber-health-no-action-note-1")), 1),
    _createElementVNode("div", _hoisted_4, [
      (props.isNoData)
        ? (_openBlock(), _createBlock(_component_b_button, {
            key: 0,
            variant: "primary",
            class: "!tw-border-0 button-verify tw-bg-[#387DFF] tw-mt-[40px] tw-w-fit tw-py-[8px] tw-px-[20px] tw-text-[13px] tw-font-medium tw-rounded-[27px]",
            onClick: rejectAssessment
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(getComponentUiText)("app-assess-recommendations-no-data-button-1")), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!props.isNoData)
        ? (_openBlock(), _createBlock(_component_b_button, {
            key: 1,
            variant: "primary",
            class: "!tw-border-0 tw-leading-[normal] button-verify tw-bg-[#387DFF] tw-mt-[40px] tw-w-fit tw-py-[8px] tw-px-[20px] tw-text-[13px] tw-font-medium tw-rounded-[27px]",
            onClick: rejectRecommendation
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
            "app-dashboard-cyber-health-no-action-blue-button-1",
          )), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!props.isNoData)
        ? (_openBlock(), _createBlock(_component_b_button, {
            key: 2,
            variant: "primary",
            class: "!tw-border-2 tw-leading-[normal] button-verify tw-bg-[transparent] tw-shadow-none tw-mt-[15px] tw-w-fit tw-py-[8px] tw-px-[20px] tw-text-[#387DFF] tw-text-[13px] tw-font-medium tw-rounded-[27px]",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update-path')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
            "app-dashboard-cyber-health-no-action-white-button-1",
          )), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})